export const aciSorting = {
    iconName: 'sorting',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M14.42 2.008a.675.675 0 00-.17.071c-.117.07-2.679 2.637-2.728 2.734-.05.1-.065.28-.032.397a.623.623 0 00.302.34.68.68 0 00.21.036c.23 0 .249-.015 1.16-.924l.836-.833v4.782c0 4.586.002 4.786.04 4.868.05.11.159.218.268.268a.688.688 0 00.422.01.644.644 0 00.276-.255l.046-.087.006-4.793.005-4.793.845.84c.54.538.874.855.925.879.12.054.332.048.453-.013a.506.506 0 00.29-.463c.003-.242.062-.173-1.394-1.635-.947-.95-1.367-1.358-1.428-1.385a.577.577 0 00-.331-.044zm-5.153 8.238a.66.66 0 00-.271.254l-.047.088-.005 4.792-.006 4.793-.844-.84c-.54-.538-.874-.855-.926-.878a.617.617 0 00-.453.012.506.506 0 00-.29.463c-.003.242-.062.173 1.395 1.635 1.021 1.025 1.365 1.357 1.438 1.39a.538.538 0 00.462-.015c.126-.069 2.7-2.636 2.757-2.751.05-.1.065-.28.033-.397a.624.624 0 00-.303-.34.684.684 0 00-.21-.036c-.23 0-.248.015-1.16.924l-.835.833V15.39c-.001-4.586-.003-4.786-.04-4.868a.515.515 0 00-.492-.306.664.664 0 00-.204.029z',
                fill: 'currentColor',
            },
        },
    },
};
